/**
 * Giriş/qeydiyyat ekranlarında kimlik zolağı.
 *
 * ⚠️ TƏHLÜKƏSİZLİK TƏLƏBİDİR, BƏZƏK DEYİL.
 *
 * 2026-09-03-də Search Console «Sahte sayfalar / Social engineering»
 * xəbərdarlığı verdi. Google-un öz tərifi belədir: «etibarlı qurum kimi
 * görünən» və «yalnız etibarlı qurum üçün edəcəyiniz şeyi — şifrə
 * paylaşmağı — etdirən» səhifə.
 *
 * Panelin giriş səhifəsi həmin profilə tam uyğun gəlirdi: e-poçt + şifrə
 * sorulurdu, üstündə «Google ilə davam et» düyməsi vardı, VƏ SƏHİFƏDƏ BİR
 * DƏNƏ DƏ KEÇİD YOX İDİ — nə ana sayta, nə şərtlərə, nə operatorun adına.
 * Avtomatik təsnifatçı üçün bu, kimliyi doğrulana bilməyən çılpaq şifrə
 * formasıdır, yəni fişinq nümunəsidir.
 *
 * ⚠️ `noindex` BUNU HƏLL ETMİR. Panel `X-Robots-Tag: noindex` göndərir,
 * amma Safe Browsing indeksləmədən ASILI OLMADAN tarayır.
 *
 * ⚠️ KEÇİDLƏR SİLİNMƏMƏLİDİR. Qanuni giriş səhifəsini fişinqdən ayıran
 * əsas siqnal budur: səhifə kimin olduğunu deyir və yoxlanıla bilən
 * ünvana keçid verir.
 *
 * ⚠️ KİMLİK MƏLUMATI TOPLAYAN HƏR EKRANDA OLMALIDIR — giriş, qeydiyyat,
 * şifrə bərpası. Yalnız birində olsa, qalanları eyni riski daşıyır.
 */
export function SiteIdentity(): React.ReactElement {
  return (
    <div className="login-identity">
      <p>
        {/* rel="noopener" — yeni tabda açılan səhifə window.opener ilə
            bizim səhifəyə toxuna bilməməlidir. */}
        <a href="https://mailora.az" target="_blank" rel="noopener">
          mailora.az
        </a>{' '}
        — Azərbaycanda qurulmuş korporativ e-poçt xidməti. Bakı, Azərbaycan.
      </p>
      <p>
        <a href="https://mailora.az/sertler/" target="_blank" rel="noopener">
          İstifadə şərtləri
        </a>
        {' · '}
        <a href="https://mailora.az/mexfilik/" target="_blank" rel="noopener">
          Məxfilik siyasəti
        </a>
        {' · '}
        <a href="mailto:support@mailora.az">support@mailora.az</a>
      </p>
      {/*
        ⚠️ BU CÜMLƏ QƏSDƏN VAR. Fişinq səhifələri istifadəçini BAŞQA
        xidmətin şifrəsini yazmağa məcbur edir. Burada açıq deyilir ki,
        gözlənilən şifrə məhz bu xidmətə aiddir — həm istifadəçini
        qoruyur, həm də səhifənin niyyətini birmənalı edir.
      */}
      <p className="login-warn">
        Yalnız Mailora hesabınızın şifrəsini yazın. Başqa xidmətin şifrəsini heç
        vaxt bu səhifəyə daxil etməyin.
      </p>
    </div>
  );
}
